import { insertNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';
import { getDefaultAccordionItemValue } from '../defaults';

export const addAccordionItem = (editor: DreamEditor, path: Path) => {
  insertNodes(editor, getDefaultAccordionItemValue(), { at: path });
};
